module.exports = __webpack_public_path__ + "static/media/premiacao_02.3c893832.jpg";